import {
  getPolygonStockData,
  getDividendsData,
  getFinancialsData,
  getRelatedCompaniesData,
  getTickerDetailsData,
  getTickerEventsData,
} from './polygonAPI';

export const FETCH_POLYGON_STOCK_DATA_REQUEST = 'FETCH_STOCK_DATA_REQUEST';
export const FETCH_POLYGON_STOCK_DATA_SUCCESS = 'FETCH_STOCK_DATA_SUCCESS';
export const FETCH_POLYGON_STOCK_DATA_FAILURE = 'FETCH_STOCK_DATA_FAILURE';
export const GET_DIVIDENDS_DATA = 'GET_DIVIDENDS_DATA';
export const GET_FINANCIALS_DATA = 'GET_FINANCIALS_DATA';
export const GET_RELATED_COMPANIES_DATA = 'GET_RELATED_COMPANIES_DATA';
export const GET_TICKER_DETAILS_DATA = 'GET_TICKER_DETAILS_DATA';
export const GET_TICKER_EVENTS_DATA = 'GET_TICKER_EVENTS_DATA';

// Fetch polygon stock data
export const fetchPolygonStockData = (symbol, date) => async (dispatch) => {
  dispatch({ type: FETCH_POLYGON_STOCK_DATA_REQUEST });
  try {
    const data = await getPolygonStockData(symbol, date);
    dispatch({ type: FETCH_POLYGON_STOCK_DATA_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: FETCH_POLYGON_STOCK_DATA_FAILURE,
      payload: error.message,
    });
  }
};

export const fetchDividendsData = (ticker) => async (dispatch) => {
  try {
    const data = await getDividendsData(ticker);
    dispatch({ type: GET_DIVIDENDS_DATA, payload: data });
  } catch (error) {
    console.warn('Error fetching dividends data:', error);
  }
};

export const fetchFinancialsData = (ticker, limit = 10) => async (dispatch) => {
  try {
    if (!ticker) throw new Error("Ticker is required for financials");

    const data = await getFinancialsData(ticker, limit);

    dispatch({
      type: GET_FINANCIALS_DATA,
      payload: { ticker, data }
    });
  } catch (error) {
    console.warn("Error fetching financials data:", error);
  }
};


export const fetchRelatedCompaniesData = (ticker) => async (dispatch) => {
  try {
    const data = await getRelatedCompaniesData(ticker);
    dispatch({ type: GET_RELATED_COMPANIES_DATA, payload: data });
  } catch (error) {
    console.warn('Error fetching related companies data:', error);
  }
};

export const fetchTickerDetailsData = (ticker) => async (dispatch) => {
  try {
    const data = await getTickerDetailsData(ticker);
    dispatch({ type: GET_TICKER_DETAILS_DATA, payload: data });
  } catch (error) {
    console.warn('Error fetching ticker details data:', error);
  }
};

export const fetchTickerEventsData = (id) => async (dispatch) => {
  try {
    const data = await getTickerEventsData(id);
    dispatch({ type: GET_TICKER_EVENTS_DATA, payload: data });
  } catch (error) {
    console.warn('Error fetching ticker events data:', error);
  }
};